module.exports = __webpack_public_path__ + "img/table-placeholder-archive.e1d28801.webp";